// 导入所有 shop 模块的国际化文件
import { messages as storeAdsMessages } from '@/lang/shop/storeAdsLang.js'
import { messages as buyShopSmsMessages } from '@/lang/shop/buyShopSmsLang.js'
import { messages as deleteApplyWithholdIntegralMessages } from '@/lang/shop/deleteApplyWithholdIntegralLang.js'
import { messages as editShopSmsSwitchMessages } from '@/lang/shop/editShopSmsSwitchLang.js'
import { messages as aShopSmsMessages } from '@/lang/shop/aShopSmsLang.js'
import { messages as cityAreaMessages } from '@/lang/shop/cityAreaLang.js'
import { messages as integralMessages } from '@/lang/shop/integralLang.js'
import { messages as integralShopGiftMessages } from '@/lang/shop/integralShopGiftLang.js'
import { messages as integralShopRuleMessages } from '@/lang/shop/integralShopRuleLang.js'
import { messages as printerMachineMessages } from '@/lang/shop/printerMachineLang.js'
import { messages as printerMachineLogMessages } from '@/lang/shop/printerMachineLogLang.js'
import { messages as shopConfigMessages } from '@/lang/shop/shopConfigLang.js'
import { messages as shopHouseMessages } from '@/lang/shop/shopHouseLang.js'
import { messages as shopMessages } from '@/lang/shop/shopLang.js'
import { messages as shopSmsDetailMessages } from '@/lang/shop/shopSmsDetailLang.js'
import { messages as shopSmsMessages } from '@/lang/shop/shopSmsLang.js'
import { messages as shopWithdrawMessages } from '@/lang/shop/shopWithdrawLang.js'
import { messages as aShopMessages } from '@/lang/shop/aShopLang.js'
import { messages as adminShopMessages } from '@/lang/shop/adminShopLang.js'
import { messages as moreShopMessages } from '@/lang/shop/moreShopLang.js'

// 合并所有国际化消息
export const messages = {
  en: {
    ...storeAdsMessages.en,
    ...buyShopSmsMessages.en,
    ...deleteApplyWithholdIntegralMessages.en,
    ...editShopSmsSwitchMessages.en,
    ...aShopSmsMessages.en,
    ...cityAreaMessages.en,
    ...integralMessages.en,
    ...integralShopGiftMessages.en,
    ...integralShopRuleMessages.en,
    ...printerMachineMessages.en,
    ...printerMachineLogMessages.en,
    ...shopConfigMessages.en,
    ...shopHouseMessages.en,
    ...shopMessages.en,
    ...shopSmsDetailMessages.en,
    ...shopSmsMessages.en,
    ...shopWithdrawMessages.en,
    ...aShopMessages.en,
    ...adminShopMessages.en,
    ...moreShopMessages.en
  },
  zh: {
    ...storeAdsMessages.zh,
    ...buyShopSmsMessages.zh,
    ...deleteApplyWithholdIntegralMessages.zh,
    ...editShopSmsSwitchMessages.zh,
    ...aShopSmsMessages.zh,
    ...cityAreaMessages.zh,
    ...integralMessages.zh,
    ...integralShopGiftMessages.zh,
    ...integralShopRuleMessages.zh,
    ...printerMachineMessages.zh,
    ...printerMachineLogMessages.zh,
    ...shopConfigMessages.zh,
    ...shopHouseMessages.zh,
    ...shopMessages.zh,
    ...shopSmsDetailMessages.zh,
    ...shopSmsMessages.zh,
    ...shopWithdrawMessages.zh,
    ...aShopMessages.zh,
    ...adminShopMessages.zh,
    ...moreShopMessages.zh
  }
} 